import ApiInterceptor from "./api";

export interface Site {
  id: number;
  name: string;
  longitude: number;
  latitude: number;
}

export interface SiteDTO {
  name: string;
  longitude: number;
  latitude: number;
}

const siteService = {
  async getAllSites(): Promise<Site[]> {
    const axiosInstance = ApiInterceptor.service(false);
    try {
      const response = await axiosInstance.get("/Sites");
      return response.data;
    } catch (error) {
      console.error("Error fetching sites:", error);
      throw error;
    }
  },

  async createSite(dto: SiteDTO): Promise<Site> {
    const axiosInstance = ApiInterceptor.service(true);
    try {
      const response = await axiosInstance.post("/Sites", dto);
      return response.data;
    } catch (error) {
      console.error("Error creating site:", error);
      throw error;
    }
  },

  async updateSite(id: number, dto: SiteDTO): Promise<Site> {
    const axiosInstance = ApiInterceptor.service(true);
    try {
      const response = await axiosInstance.put(`/Sites/${id}`, dto);
      return response.data;
    } catch (error) {
      console.error("Error updating site:", error);
      throw error;
    }
  },

  async deleteSite(id: number): Promise<void> {
    const axiosInstance = ApiInterceptor.service(true);
    try {
      await axiosInstance.delete(`/Sites/${id}`);
    } catch (error) {
      console.error("Error deleting site:", error);
      throw error;
    }
  },

  async importCsv(file: File): Promise<{ imported: number; message: string }> {
    const axiosInstance = ApiInterceptor.service(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axiosInstance.post("/Sites/import-csv", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      console.error("Error importing CSV:", error);
      throw error;
    }
  },
};

export default siteService;
